import { HomeworkSolutionQueryDto } from "../../interfaces";

//#region Get Homework Solution Queries

export const GET_HOMEWORK_SOLUTION_QUERIES = "GET_HOMEWORK_SOLUTION_QUERIES";
export const GET_HOMEWORK_SOLUTION_QUERIES_SUCCESS: any =
  "GET_HOMEWORK_SOLUTION_QUERIES_SUCCESS";
export const GET_HOMEWORK_SOLUTION_QUERIES_ERROR: any =
  "GET_HOMEWORK_SOLUTION_QUERIES_ERROR";

export interface GetHomeworkSolutionQueriesAction {
  type: typeof GET_HOMEWORK_SOLUTION_QUERIES;
  payload: {};
}

export interface GetHomeworkSolutionQueriesSuccessAction {
  type: typeof GET_HOMEWORK_SOLUTION_QUERIES_SUCCESS;
  payload: HomeworkSolutionQueryDto;
}

export interface GetHomeworkSolutionQueriesErrorAction {
  type: typeof GET_HOMEWORK_SOLUTION_QUERIES_ERROR;
  payload: any;
}
//#endregion

//#region Update Homework Solution Queries

export const UPDATE_HOMEWORK_SOLUTION_QUERIES =
  "UPDATE_HOMEWORK_SOLUTION_QUERIES";
export const UPDATE_HOMEWORK_SOLUTION_QUERIES_SUCCESS: any =
  "UPDATE_HOMEWORK_SOLUTION_QUERIES_SUCCESS";
export const UPDATE_HOMEWORK_SOLUTION_QUERIES_ERROR: any =
  "UPDATE_HOMEWORK_SOLUTION_QUERIES_ERROR";

export interface UpdateHomeworkSolutionQueriesAction {
  type: typeof UPDATE_HOMEWORK_SOLUTION_QUERIES;
  payload: { request: HomeworkSolutionQueryDto };
}

export interface UpdateHomeworkSolutionQueriesSuccessAction {
  type: typeof UPDATE_HOMEWORK_SOLUTION_QUERIES_SUCCESS;
  payload: HomeworkSolutionQueryDto;
}

export interface UpdateHomeworkSolutionQueriesErrorAction {
  type: typeof UPDATE_HOMEWORK_SOLUTION_QUERIES_ERROR;
  payload: any;
}
//#endregion

// Export a union type that represents all possible actions
export type ActionTypes =
  | GetHomeworkSolutionQueriesAction
  | GetHomeworkSolutionQueriesSuccessAction
  | GetHomeworkSolutionQueriesErrorAction
  | UpdateHomeworkSolutionQueriesAction
  | UpdateHomeworkSolutionQueriesSuccessAction
  | UpdateHomeworkSolutionQueriesErrorAction;
